import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrderItem } from 'src/app/class/OrderItem';

@Component({
  selector: 'app-customers-choice',
  templateUrl: './customers-choice.component.html',
  styleUrls: ['./customers-choice.component.scss']
})
export class CustomersChoiceComponent implements OnInit {
  @Input()
  choices: Array<OrderItem>;

  @Input()
  verbiage: string;

  @Input()
  choiceOOS: boolean;
  
  @Output()
  emitterOfAcceptance = new EventEmitter();

  @Output()
  emitterOfRejection = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  sendAcceptDataBack(item: OrderItem) {
    this.emitterOfAcceptance.emit(item);
  }

  sendRejectDataBack(item: OrderItem) {
    this.emitterOfRejection.emit(item);
  }
}
